import styled from 'styled-components';

// Graficos do painel de desempenho. Mesmo card dos SummaryCards (borda, raio e
// sombra), para o painel nao ganhar um segundo estilo de card.
export const ChartGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ChartCard = styled.div.attrs({})`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 12px 16px;
  min-width: 0;
  ${(props) => (props.$wide ? 'grid-column: 1 / -1;' : '')}
`;

export const ChartTitle = styled.div.attrs({})`
  font-size: 12px;
  font-weight: 600;
  color: #718096;
  text-transform: uppercase;
`;

export const ChartSubtitle = styled.div.attrs({})`
  font-size: 12px;
  color: #a0aec0;
  margin-top: 2px;
`;

export const ChartEmpty = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.$height || 240}px;
  font-size: 13px;
  color: #a0aec0;
`;
